import React, { useEffect } from "react"

import { useVariableData } from "../../context/VariableDataContext"

import dayjs from "dayjs"

import "./index.css"
import BoostDash from "./BoostDash"
import MetroDash from "./MetroDash"

const currentDayjs = dayjs()

function VisualDashboard() {
  const { client, selectedClientInfo } = useVariableData() // Get token from context

  return (
    <div id="dash-wrapper" style={{ marginBottom: "20px" }}>
      <BoostDash />
    </div>
  )
}
export default VisualDashboard
